import { createTheme } from "@mui/material";
import { responsiveFontSizes } from "@mui/material/styles";
import { INFO_COLOR, PRIMARY_COLOR, SECONDARY_COLOR } from "../_const/color.const";
import '@mui/x-date-pickers/themeAugmentation';

let theme = createTheme({
    palette: {
        primary: { main: PRIMARY_COLOR },
        secondary: { main: SECONDARY_COLOR },
    },

    typography: {
        htmlFontSize: 16, //base

        h1: { fontWeight: 700, lineHeight: 1.2, fontSize: '2.25rem' }, 
        h2: { fontWeight: 700, lineHeight: 1.25, fontSize: '1.875rem' },
        h3: { fontWeight: 700, lineHeight: 1.25, fontSize: '1.5rem' },
        h4: { fontWeight: 600, lineHeight: 1.3, fontSize: '1.25rem' },
        h5: { fontWeight: 600, lineHeight: 1.35, fontSize: '1.125rem' },
        h6: { fontWeight: 600, lineHeight: 1.4, fontSize: '1rem' },

        body1: { fontSize: '1rem', lineHeight: 1.6 },
        body2: { fontSize: '0.875rem', lineHeight: 1.55 },

        subtitle1: { fontSize: '0.95rem', fontWeight: 500 },
        subtitle2: { fontSize: '0.85rem', fontWeight: 500 },

        button: { textTransform: 'none', fontWeight: 600 },
    },

    components: {
        MuiFormHelperText: {
            styleOverrides: { root: { color: INFO_COLOR } },
        },
        MuiPaper: {
            styleOverrides: { root: { padding: '16px' } },
        },

        MuiDatePicker: {
            defaultProps: { slotProps: { popper: { placement: 'bottom-start' } } },
        },
        MuiDateTimePicker: {
            defaultProps: { slotProps: { popper: { placement: 'bottom-start' } } },
        },
        MuiPickersPopper: {
            styleOverrides: {
                paper: { borderRadius: 12, boxShadow: '0 8px 24px rgba(0,0,0,0.18)' },
            },
        },
        MuiPickersLayout: {
            styleOverrides: {
                root: { padding: 8 },
                actionBar: { padding: '8px 12px' },
            },
        },
        MuiDateCalendar: {
            styleOverrides: { root: { borderRadius: 12 } },
        },
        MuiPickersDay: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    '&.Mui-selected': { boxShadow: '0 2px 6px rgba(0,0,0,0.15)' },
                    '&:not(.Mui-selected):hover': { backgroundColor: 'rgba(0,0,0,0.04)' },
                },
                today: { border: '1px solid' },
            },
        },
        MuiMultiSectionDigitalClock: {
            styleOverrides: { root: { borderRadius: 12 } },
        },
        MuiContainer: {
            styleOverrides: {
                root: {
                    paddingLeft: '0px', //for mobile
                    paddingRight: '0px',

                    '@media (min-width:600px)': { //back to default 
                        paddingLeft: '16px',     
                        paddingRight: '16px',
                    }
                }
            }
        },
    },
});

theme = responsiveFontSizes(theme, {
    factor: 2.2,                 // how aggressively sizes scale up
    breakpoints: ['sm', 'md', 'lg'],
    disableAlign: false,         // keeps line-heights aligned to 4px grid
});

export { theme };
